export const REVIEW_PAGE_BG = 'bg-[#f9fafb]';
export const REVIEW_CARD_GAP = 'gap-2.5';
export const REVIEW_CARD_PAD = 'p-3';

export function reviewCardClass(status = 'normal', extra = '') {
  return `rounded-xl bg-white shadow-sm border border-gray-200 ${REVIEW_CARD_PAD} ${extra}`;
}
